import { Box } from '@mui/material';
import type { ColDef } from '@siloreal:modules:private/silobag-list/config/extra/types';
import { FALLBACK_STRING, FieldCellStack, FieldPrimaryText, MetaRow } from './column-field-ui';
import * as HOOKS from '@siloreal:shared:hooks';

type OrganizationCellProps = {
  organizationName?: string | null;
  companyName?: string | null;
};

export function buildOrganizationColumn(): ColDef {
  return {
    field: 'organization_id',
    headerName: HOOKS.useLocale.getState().t('temp.common.organization'),
    minWidth: 240,
    flex: 1,
    renderCell: ({ row }) => (
      <OrganizationCell organizationName={row.organizations?.name} companyName={row.companies?.name} />
    ),
  };
}

function OrganizationCell({ organizationName, companyName }: OrganizationCellProps) {
  const hasOrganization = Boolean(organizationName?.trim());
  const hasCompany = Boolean(companyName?.trim());
  const primaryName = organizationName?.trim() || FALLBACK_STRING;
  const secondaryName = companyName?.trim() || FALLBACK_STRING;
  const i18n = HOOKS.useLocale();

  return (
    <FieldCellStack>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <FieldPrimaryText
          title={hasOrganization ? primaryName : i18n.t('temp.common.organization_unavailable')}
          disabled={!hasOrganization}
        >
          {primaryName}
        </FieldPrimaryText>

        <MetaRow
          tag="CIA."
          disabled={!hasCompany}
          valueTitle={hasCompany ? secondaryName : i18n.t('temp.common.company_unavailable')}
        >
          {secondaryName}
        </MetaRow>
      </Box>
    </FieldCellStack>
  );
}
